// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, "@media screen and (max-width: 1366px) {\n#upgrade[data-v-6a6a1d10] {\n    max-width: 100%;\n}\n}\n", "",{"version":3,"sources":["/app/src/pages/upgrade/list/style_notebook.less"],"names":[],"mappings":"AAAA;AAEC;IACC,eAAA;AAAA;AACF","file":"style_notebook.less","sourcesContent":["@media screen and (max-width: 1366px) {\n\n\t#upgrade {\n\t\tmax-width: 100%;\n\t}\n\n}\n"]}]);
// Exports
module.exports = exports;
